import React, { Component } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { FormErrors } from "./FormErrors";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import "./contact-form.styles.scss";

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
      formErrors: { name: "", email: "", phone: "", subject: "", message: "" },
      nameValid: false,
      emailValid: false,
      phoneValid: false,
      subjectValid: false,
      messageValid: false,
      formValid: false,
    };
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let nameValid = this.state.nameValid;
    let emailValid = this.state.emailValid;
    let phoneValid = this.state.phoneValid;
    let subjectValid = this.state.subjectValid;
    let messageValid = this.state.messageValid;

    switch (fieldName) {
      case "name":
        nameValid = value.length >= 2;
        fieldValidationErrors.name = nameValid ? "" : "Enter a valid name";
        break;
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid
          ? ""
          : "Enter a valid email address";
        break;
      case "phone":
        phoneValid = value.match(
          /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
        );
        fieldValidationErrors.phone = phoneValid
          ? ""
          : "Enter a valid phone number";
        break;
      case "subject":
        subjectValid = value.length >= 2;
        fieldValidationErrors.subject = subjectValid
          ? ""
          : "Enter a valid subject";
        break;
      case "message":
        messageValid = value.length >= 3;
        fieldValidationErrors.message = messageValid
          ? ""
          : "Enter a valid message";
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        emailValid: emailValid,
        phoneValid: phoneValid,
        subjectValid: subjectValid,
        messageValid: messageValid,
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({
      formValid:
        this.state.nameValid &&
        this.state.emailValid &&
        this.state.phoneValid &&
        this.state.subjectValid &&
        this.state.messageValid,
    });
  }

  errorClass(error) {
    return error.length === 0 ? "" : "has-error";
  }

  handleSubmit = (event) => {
    if (event) event.preventDefault();
    if (this.state.formValid) {
      let data = {
        name: this.state.name,
        email: this.state.email,
        phone: this.state.phone,
        subject: this.state.subject,
        message: this.state.message,
      };
      axios
        .post(API_URL.CONTACT, data)
        .then((res) => {
          if (res.data.code === 200) {
            NotificationManager.success(res.data.msg, "Successful!", 2000);
            this.setState({
              name: "",
              email: "",
              phone: "",
              subject: "",
              message: "",
              formErrors: {
                name: "",
                email: "",
                phone: "",
                subject: "",
                message: "",
              },
              nameValid: false,
              emailValid: false,
              phoneValid: false,
              subjectValid: false,
              messageValid: false,
              formValid: false,
            });
          } else {
            NotificationManager.error(res.data.msg, "Error!");
          }
        })
        .catch((err) => {
          NotificationManager.error("Error while submit inquiry!", "Error!");
        });
    }
  };

  render() {
    return (
      <Form
        className="contact_form"
        id="contact_form"
        method="post"
        onSubmit={this.handleSubmit}
      >
        <Row>
          <Col md="6">
            <div
              className={`form-group ${this.errorClass(
                this.state.formErrors.name
              )}`}
            >
              <input
                id="form_name"
                name="name"
                className="form-control"
                required="required"
                type="text"
                placeholder="Name"
                value={this.state.name}
                onChange={this.handleUserInput}
              />
              <FormErrors formErrors={this.state.formErrors} field="name" />
            </div>
          </Col>
          <Col md="6">
            <div
              className={`form-group ${this.errorClass(
                this.state.formErrors.email
              )}`}
            >
              <input
                id="form_email"
                name="email"
                className="form-control required email"
                required="required"
                type="email"
                placeholder="Email"
                value={this.state.email}
                onChange={this.handleUserInput}
              />
              <FormErrors formErrors={this.state.formErrors} field="email" />
            </div>
          </Col>
          <Col md="6">
            <div
              className={`form-group ${this.errorClass(
                this.state.formErrors.phone
              )}`}
            >
              <input
                id="form_phone"
                name="phone"
                className="form-control required phone"
                required="required"
                type="text"
                placeholder="Phone"
                value={this.state.phone}
                onChange={this.handleUserInput}
              />
              <FormErrors formErrors={this.state.formErrors} field="phone" />
            </div>
          </Col>
          <Col md="6">
            <div
              className={`form-group ${this.errorClass(
                this.state.formErrors.subject
              )}`}
            >
              <input
                id="form_subject"
                name="subject"
                className="form-control required"
                required="required"
                type="text"
                placeholder="Subject"
                value={this.state.subject}
                onChange={this.handleUserInput}
              />
              <FormErrors formErrors={this.state.formErrors} field="subject" />
            </div>
          </Col>
          <Col sm="12">
            <div
              className={`form-group ${this.errorClass(
                this.state.formErrors.message
              )}`}
            >
              <textarea
                id="form_message"
                name="message"
                className="form-control required"
                rows="8"
                required
                placeholder="Your Message"
                value={this.state.message}
                onChange={this.handleUserInput}
              ></textarea>
              <FormErrors formErrors={this.state.formErrors} field="message" />
            </div>
            <div className="form-group mb0">
              <button
                type="submit"
                className="btn btn-lg btn-thm"
                disabled={!this.state.formValid}
              >
                Send Message
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default ContactForm;
